import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-content-center" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "me-5 position-relative" }
const _hoisted_4 = { class: "symbol symbol-90px symbol-circle" }
const _hoisted_5 = {
  key: 0,
  class: "symbol-label bg-light-primary text-white fw-bold"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_8 = { class: "mb-1 fs-2 text-white fw-bolder" }
const _hoisted_9 = { class: "fw-bold fs-5 text-gray-600" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-5" }, "Contact Information", -1)
const _hoisted_11 = { class: "d-flex flex-wrap" }
const _hoisted_12 = { class: "me-5" }
const _hoisted_13 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Identity", -1)
const _hoisted_15 = { class: "text-gray-800" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Email", -1)
const _hoisted_17 = { class: "text-gray-800" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "Phone Number", -1)
const _hoisted_19 = { class: "text-gray-800" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "text-muted min-w-125px w-125px" }, "StageCode", -1)
const _hoisted_21 = { class: "text-gray-800" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", { class: "me-2" }, "Medical Notes", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-4" }, "Emergency Contacts", -1)
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_28 = { class: "mb-1 text-gray-800" }
const _hoisted_29 = { class: "fw-bold fs-6 text-gray-600" }
const _hoisted_30 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-4" }, "Group Memberships", -1)
const _hoisted_32 = { key: 4 }
const _hoisted_33 = {
  key: 5,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: _ctx.person.fullName,
    ref: "modal",
    "has-toolbar": false,
    "has-header": false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.person.avatar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.person.fullName[0]), 1))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    alt: "Pic",
                    src: _ctx.person.avatar
                  }, null, 8, _hoisted_6))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.person.fullName), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.person.pronouns), 1)
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.genderIdentity), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.emailAddress), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.phoneNumber), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.person.stageCode), 1)
                ])
              ])
            ])
          ])
        ]),
        _hoisted_22,
        (_ctx.person.medical !== '' && _ctx.person.medical !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.person.medical), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, " No Medical Notes ")),
        _hoisted_25,
        (_ctx.person.emergencyContacts.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.person.emergencyContacts, (contact) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex align-items-center",
                  key: contact.emergencyContactId
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(contact.name) + " - " + _toDisplayString(contact.relationship), 1),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatPhone(contact.contact)), 1)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, " No Emergency Contacts ")),
        _hoisted_31,
        (_ctx.getPersonsGroups(_ctx.person.accountId).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPersonsGroups(_ctx.person.accountId), (group) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: group.groupId,
                  class: "badge badge-light-primary text-white me-2 mb-2 px-4 py-3"
                }, _toDisplayString(group.name), 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, " This person is not a member of any groups. "))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}